module.exports = __webpack_public_path__ + "img/OT.5c64375a.png";